
import {
  defineComponent, onMounted, ref, shallowRef, nextTick, reactive, computed,onUnmounted, watch,
} from 'vue';
import {
  Table, Select, ConfigProvider, DatePicker, message,
} from 'ant-design-vue';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import * as echarts from 'echarts';
import axios from 'axios';
import { serverIp, } from '@/configs/index';

import moment from 'moment';
import { useStore, } from 'vuex';

import {
  hotTableStatistics, queryHotTable,
} from '../hotspotGridReq';

const { Option, } = Select;
const { RangePicker, } = DatePicker;

export default defineComponent({
  components: {
    Table, Select, Option, ConfigProvider, RangePicker,
  },
  setup (props,{ emit, }) {
    const store = useStore();

    // 后端返回的热点网格菜单权限（4006）
    const gridOption = computed(() => store.state.userCenter.userGrantDataRights.find((item: any) => item.id === '4006'));
    // 时间类型
    const timeType = [
      {
        label: '日',
        key: 'day',
      },
      {
        label: '周',
        key: 'week',
      },
      {
        label: '月',
        key: 'month',
      },
      {
        label: '自定义',
        key: 'custom',
      },
    ];

    const rangData = ref<any>([]);

    // 筛选条件表单
    const formData = reactive({
      // 选中地点
      areaValue: ['nanjing', 'gaochun',],
      // 时间类型
      timeType: 'month',
      startTime: '',
      endTime: '',
    });

    const pieOption = {
      legend: {
        orient: 'vertical',
        right: 80,
        top: 18,
        bottom: 20,
        // 图例间距
        itemGap: 10,
        itemWidth: 18,
        inactiveBorderWidth: 0,
        inactiveBorderColor: 'white',
        itemHeight: 14,
        textStyle: {
          fontSize: 14,
          fontWeight: 400,
          fontFamily: 'Microsoft YaHei',
          // 主标题文字颜色
          color: 'rgba(68, 68, 68, 1)',
        },
      },
      series: {
        type: 'pie',
        radius: [50, 70,],
        left: '7%',
        width: 200,
        colorBy: 'data',
        itemStyle: {
          borderColor: '#fff',
          borderWidth: 1,
        },
        label: {
          show: false,
        },
        data: [
          { value: 1, name: '淳西1', },
          { value: 1, name: '淳西2', },
          { value: 1, name: '淳西3', },
          { value: 1, name: '淳淳西4', },
          { value: 1, name: '淳西5', },
          { value: 1, name: '淳西6', },
          { value: 1, name: '淳淳西7', },
          { value: 1, name: '淳西8', },
          { value: 1, name: '淳西9', },
          { value: 1, name: '淳西10', },
          { value: 1, name: '淳西11', },
          { value: 1, name: '淳淳西12', },
        ],
      },
      tooltip: {
        show: true,
        formatter: (param: any) => {
          const {
            name, value, percent,
          } = param;

          return `<div><div style="font-weight:bold;">${name}</div>${value}个(${percent}%)</div>`;
        },
        textStyle: {
          align: 'left',
          fontSize: '16',
        },
      },
    };

    const lineOption = {
      grid: {
        top: '20%',
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true,
      },
      tooltip: {
        show: true,
      },
      xAxis: {
        type: 'category',
        axisLabel: {
          show: true,
        },
        data: [],
      },
      yAxis: {
        type: 'value',
      },
      series: {
        data: [],
        tooltip: {
          valueFormatter: (val: string) => `${val}个`,
        },
        type: 'line',
        smooth: true,
      },
    };
    const pieChartShow = ref<boolean>(false);
    const lineChartShow = ref<boolean>(false);
    const dialogHide = ref<boolean>(false);

    // 产品类型（pm2_5/pm10）
    const productType = ref('');

    const gridDetailData = ref({
      gridCount: 237,
      examineGridCount: 27,
    });

    // 表格行配置
    const columns = ref<any[]>([
      {
        title: '时间',
        dataIndex: 'time',
        slots: { customRender: 'time', },
        key: 'time',
        align: 'center',
      },
      {
        title: '数量',
        dataIndex: 'count',
        key: 'count',
        align: 'center',
      },
      {
        title: '疑似企业',
        dataIndex: 'company',
        key: 'company',
        align: 'center',
      },
    ]);
    // 表格数据
    const tableData = ref<any[]>([]);
    // 每页展示条数
    const pageData = reactive({
      pageSize: 3,
      current: 1,
      total: 0,
    });

    const dataState = reactive({
      // selectedRowKeys: [0,],

      /*
       * selectedIds: [0,],
       * selectedItems: [{
       *   company: '桠溪',
       *   count: 22,
       *   id: 1,
       *   time: 2022092604,
       * },],
       */
    });

    const rowSelection = reactive({
      selectedRowKeys: [] as any[],
    });

    const currentTime = computed(() => {
      const startStr = 'YYYY-MM-DD 00:00';
      const endStr = 'YYYY-MM-DD HH:00';

      const weekOfDay = moment().format('E');
      const momentOfDay = moment().format('MM');

      switch (formData.timeType) {
      case 'day':
        return `${moment().format(startStr)} ~ ${moment().format(endStr)}`;

      case 'week':
        return `${moment().subtract(parseFloat(weekOfDay) - 1, 'day').format(startStr)} ~ ${moment().format(endStr)}`;

      case 'month':
        return `${moment().format('YYYY-MM-01 00:00')} ~ ${moment().format(endStr)}`;

      default:
        break;
      }

      return null;
    });

    // 表格页码改变处理事件
    const handleTableChange = (page: any, size: any): void => {
      pageData.current = page;
      pageData.pageSize = size;

      const tableParams = {
        endTime: formData.endTime,
        // regionId: '320125000000',
        startTime: formData.startTime,
        targetType: productType.value,
        timeType: formData.timeType,
        pageNum: pageData.current,
        pageSize: pageData.pageSize,
      };

      queryHotTable(tableParams).then((result: any) => {
        const res = result.data;
        const { list, total, } = res;

        tableData.value = list;

        pageData.total = total;

        const rowClickData = {
          ...tableData.value[0],
          targetType: productType.value,
        };

        rowSelection.selectedRowKeys = [0,];

        emit('rowClick', rowClickData);
      });
    };

    // 饼图
    const pieChart = shallowRef<any>({});
    // 曲线图
    const lineChart = shallowRef<any>({});

    const disabledDate = (endValue: string | any): boolean => endValue?.valueOf() <= moment().subtract(3, 'months')?.valueOf() ||
      endValue?.valueOf() >= moment().valueOf();

    /**
     *  重置图表
     * @param {any} chart 图表集合
     * @return {void}
     */
    const reSize = (chart: any): any => {
      if (Object.keys(chart).length) {
        chart.resize();
      }
    };

    /**
     *  配置线状图
     * @param {any} val 配置项
     * @param {any} chart 配置项
     * @return {void}
     */
    const setChart = (val: any, chart: any) => {
      nextTick(() => {
        if (val && Object.keys(chart).length) {
          // 不和之前的option合并
          chart.setOption(val, true);
          reSize(chart);
        }
      });
    };

    const initChart = () => {
      const pieChartContainer = document.getElementById('pie-chart') as HTMLElement;

      pieChart.value = echarts.init(pieChartContainer);

      const lineChartContainer = document.getElementById('line-chart') as HTMLElement;

      lineChart.value = echarts.init(lineChartContainer);
    };

    // 增加rightFlag入参，用于判断是否外部调用，刷新右侧数据-弃用（初始化默认选中第一条）
    const loadGridData = () => {
      const params = {
        endTime: formData.endTime,
        // regionId: '320125000000',
        startTime: formData.startTime,
        targetType: productType.value,
        timeType: formData.timeType,
      };

      hotTableStatistics(params).then((result: any) => {
        const res = result.data;
        const {
          hotCount,repairCount, areaPie, timeCount,
        } = res;

        gridDetailData.value.gridCount = hotCount;
        gridDetailData.value.examineGridCount = repairCount;

        if (areaPie && areaPie.length) {
          pieOption.series.data = areaPie.map((item: any) => ({ value: item.value, name: item.name.replace('高淳区', ''), }));
          if (pieOption.series.data.length > 6) {
            pieOption.legend.right = 20;
          }
          pieChartShow.value = true;
          setChart(pieOption, pieChart.value);
        } else {
          pieChartShow.value = false;
        }

        if (timeCount.times && timeCount.times.length) {
          lineChartShow.value = true;
          lineOption.xAxis.data = timeCount.times.map((item:string) => {
            if (formData.timeType === 'day') {
              return moment(item, 'YYYYMMDDHH').format('MM-DD HH:00');
            }

            return moment(item).format('MM-DD');
          });
          lineOption.series.data = timeCount.counts;

          setChart(lineOption, lineChart.value);
        } else {
          lineChartShow.value = false;
        }
      });
      const tableParams = {
        endTime: formData.endTime,
        // regionId: '320125000000',
        startTime: formData.startTime,
        targetType: productType.value,
        timeType: formData.timeType,
        pageNum: pageData.current,
        pageSize: pageData.pageSize,
      };

      queryHotTable(tableParams).then((result: any) => {
        const res = result.data;
        const { list, total, } = res;

        tableData.value = list;

        pageData.total = total;

        const rowClickData = {
          ...tableData.value[0],
          targetType: productType.value,
        };

        rowSelection.selectedRowKeys = [0,];

        emit('rowClick', rowClickData);
      });
    };

    const oldTime = ref();

    /**
     * @method changeType
     * @param {any} val 类型
     * @return {void} 切换
     */
    const changeType = (): void => {
      pageData.current = 1;
      loadGridData();
    };

    /**
     * @method handleSelect
     * @param {any} val 类型
     * @return {void} 切换
     */
    const handleSelect = (val: any): void => {
      pageData.current = 1;
      formData.timeType = val;
      if (val !== 'custom') {
        rangData.value = [];
        formData.startTime = '';
        formData.endTime = '';
        loadGridData();
      }
    };

    const okFlag = ref(false);

    const onTimeChange = (dates: any) => {
      okFlag.value = true;

      formData.startTime = dates[0].format('YYYYMMDDHH');
      formData.endTime = dates[1].format('YYYYMMDDHH');

      loadGridData();
    };

    const openStartChange = (status: any) => {
      if (status) {
        oldTime.value = rangData.value;
      } else if (!okFlag.value) {
        rangData.value = oldTime.value;
      }

      okFlag.value = false;
    };

    const customRow = (record: any, index: number) => ({
      onClick: () => {
        // dataState.selectedRowKeys.splice(0, 1, index);

        // dataState.selectedItems = [record,];

        rowSelection.selectedRowKeys = [index,];

        // dataState.selectedIds = record.id;

        const rowClickData = {
          ...record,
          targetType: productType.value,
        };

        emit('rowClick', rowClickData);
      },
    });

    const hide = () => {
      dialogHide.value = !dialogHide.value;
      emit('leftDialogHide', dialogHide.value);
    };

    const exportList = (searchData?: any) => {
      const params = {
        endTime: formData.endTime,
        regionId: '320125000000',
        startTime: formData.startTime,
        targetType: productType.value,
        timeType: formData.timeType,
        pageNum: pageData.current,
        pageSize: pageData.pageSize,
      };

      axios({
        method: 'POST',
        url: `${serverIp}/hotspotGridController/exportHotTable`,
        data: params,
        responseType: 'blob',
      }).then(({ data, }) => {
        const link = document.createElement('a');
        const blob = new Blob([data,], { type: 'application/vnd.ms-excel', });

        link.style.display = 'none';
        // 创建下载的链接
        link.href = URL.createObjectURL(blob);
        // 给下载后的文件命名
        link.setAttribute('download', '逐时列表.xlsx');
        document.body.appendChild(link);
        link.click();
        // 下载完成移除元素
        document.body.removeChild(link);
        // 释放掉blob对象
        window.URL.revokeObjectURL(link.href);
      });
    };

    watch(() => gridOption.value,(options:any) => {
      if (options) {
        productType.value = options.buttonChildren[0]?.key;
        loadGridData();
      }
    },{ immediate: true, });

    onMounted(() => {
      initChart();
    });

    onUnmounted(() => {
      echarts.dispose(pieChart);
      pieChart.value = null;
      echarts.dispose(lineChart);
      lineChart.value = null;
    });

    return {
      zhCN,
      timeType,
      formData,
      pieOption,
      productType,
      gridDetailData,
      pieChartShow,
      lineChartShow,
      columns,
      tableData,
      pageData,
      dialogHide,
      moment,
      rowSelection,
      rangData,
      currentTime,
      gridOption,
      loadGridData,
      customRow,
      changeType,
      handleSelect,
      disabledDate,
      handleTableChange,
      hide,
      onTimeChange,
      openStartChange,
      exportList,
    };
  },
});
